var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":_vm.label,"type":"is-dark","dashed":"","position":"is-bottom"}},[_c('span',[_c('i',{staticClass:"mdi mdi-18px",class:("mdi-" + _vm.icon)})]),_vm._v(" "),_c('b-icon',{staticClass:"sort-icon",class:{
      'is-desc': _vm.sortDirection == 'desc',
      'is-invisible': _vm.column.$table.currentSortColumn !== _vm.column
    },attrs:{"icon":_vm.sortIcon,"both":"","size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }